<template>
  <Modal  :modalModel="this.$modal" @approve="this.$modal.approveCallback" @close="this.$modal.close()" />
  <MarketingConsentModal
    :active="showMarketingConsentPrompt"
    @answered="onMarketingConsentAnswered"
    @dismissed="marketingConsentDismissedThisSession = true"
  />
  <router-view />
</template>

<script>
import store from './store'
import UserService from '../../daoSource/services/user.service'
import Modal from '../../daoSource/components/ui/ModalDialog'
import MarketingConsentModal from '../../daoSource/components/ui/MarketingConsentModal'
import brand from '../../daoSource/services/brand.service'

export default {
  name: 'App',
  data() {
    return {
      RefreshTokenInterval: process.env.VUE_APP_RefreshTokenIntervalInMinutes * 60 * 1000,
      marketingConsentDismissedThisSession: false,
    }
  },
  components: {
    Modal,
    MarketingConsentModal
  },
  computed: {
    showMarketingConsentPrompt() {
      const user = this.$store.state.userData
      return !!user && user.UsrType === 2 && !user.EmailMarketingConsentAt && !this.marketingConsentDismissedThisSession
    }
  },
  mounted() {
    if(this.$store.state.loggedInState){
      this.$store.dispatch('loadSessionUser')
    }
    this.initiateRefreshToken()
  },
  watch: {
    $route (to) {
      this.onRouteChange(to)
    }
  },
  methods: {
    onRouteChange (route) {
      document.title = route.meta.title || brand.name
    },
    onMarketingConsentAnswered (consent) {
      if (this.$store.state.userData) {
        this.$store.state.userData.EmailMarketingConsent = consent
        this.$store.state.userData.EmailMarketingConsentAt = new Date()
      }
    },
    initiateRefreshToken: function (){
      let vm = this
      this.refreshToken()
      setInterval(() => {
        vm.refreshToken()
      }, this.RefreshTokenInterval)
    },
    refreshToken: function () {
      if (store.state.loggedInState) {
        UserService.refreshMomsiteUserAccessToken().then((response) => {
          if (response && response.data.Status) {
            this.$store.dispatch(
              'refreshAccessToken',
              response.data.Object.AccessToken
            )
          } else {
            this.$store.dispatch('unauthorizedAction')
          }
        })
      }
    },
  }
}
</script>
<style src="@vueform/multiselect/themes/default.css"></style>
